import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from '@angular/fire/firestore';

export enum PayoutStatus {
  REQUESTED = 'requested',
  SENT_FOR_PAYMENT = 'sent_for_payment',
  PAID = 'paid',
  CANCELLED = 'cancelled',
}

export interface Payout {
  id?: string;
  userId: string;
  userEmail: string;
  paymentName: string;
  paymentEmail: string;
  amount: number;
  status: PayoutStatus;
  createdAt: Date;
  updatedAt: Date;
}

export const payoutConverter: FirestoreDataConverter<Payout> = {
  toFirestore(payout: Payout): DocumentData {
    return {
      ...payout,
      createdAt:
        payout.createdAt instanceof Date
          ? Timestamp.fromDate(payout.createdAt)
          : payout.createdAt,
      updatedAt:
        payout.updatedAt instanceof Date
          ? Timestamp.fromDate(payout.updatedAt)
          : payout.updatedAt,
    };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): Payout {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      userId: data['userId'],
      userEmail: data['userEmail'],
      paymentName: data['paymentName'],
      paymentEmail: data['paymentEmail'],
      amount: data['amount'],
      status: data['status'] as PayoutStatus,
      createdAt: data['createdAt']?.toDate() || new Date(),
      updatedAt: data['updatedAt']?.toDate() || new Date(),
    };
  },
};
